import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useRef, useState } from "react";
import { BREAKPOINT_MEDIUM } from "@jti/fe-common";
import { Icon } from "../../components/Icon/Icon";
import { TextWordBreakWrapper } from "../../components/TextWordBreakWrapper/TextWordBreakWrapper";
import Back from "../../icons/back.svg";
import Checkmark from "../../icons/checkmark-round.svg";
import Expired from "../../icons/expired.svg";
import Information from "../../icons/information.svg";
import styles from "./PageTitle.module.scss";
export const PageTitle = memo(({ variant = null, title, text, className = "", contentClassName = "" }) => {
    const pageTitleWrapper = useRef(null);
    const [isInColumn, setIsInColumn] = useState(false);
    const iconComponent = {
        checkmark: Checkmark,
        error: Information,
        info: Information,
        expired: Expired,
        back: Back,
    };
    useEffect(() => {
        setIsInColumn(pageTitleWrapper.current?.offsetWidth <= BREAKPOINT_MEDIUM);
    }, []);
    return (_jsx("div", { "data-testid": "pageTitle", className: `${styles.container} ${className} ${variant ? styles[variant] : styles.default}`, children: _jsxs("div", { ref: pageTitleWrapper, className: `${styles.wrapper} ${isInColumn ? styles.column : ""}`, children: [variant && _jsx(Icon, { component: iconComponent[variant], className: styles.icon, width: "45px", height: "45px" }), _jsxs(TextWordBreakWrapper, { className: `${styles.content} ${contentClassName}`, children: [_jsx("span", { className: styles.header, children: title }), Boolean(text) && _jsx("span", { className: styles.text, children: text })] })] }) }));
});
//# sourceMappingURL=PageTitle.js.map